module.exports = __webpack_public_path__ + "static/media/formIcon.9ae38573.svg";